import { merge } from 'lodash-es';
import {
  fetchLdap,
  fetchLdapDefault,
  saveLdap
} from './api';

export const FETCH_LDAP = 'FETCH_LDAP';
export const FETCH_LDAP_SUCCESS = 'FETCH_LDAP_SUCCESS';
export const FETCH_LDAP_ERROR = 'FETCH_LDAP_ERROR';
export const FETCH_LDAP_DEFAULTS = 'FETCH_LDAP_DEFAULTS';
export const FETCH_LDAP_DEFAULTS_SUCCESS = 'FETCH_LDAP_DEFAULTS_SUCCESS';
export const FETCH_LDAP_DEFAULTS_ERROR = 'FETCH_LDAP_DEFAULTS_ERROR';
export const SAVE_LDAP = 'SAVE_LDAP';
export const SET_LDAP_KIND = 'SET_LDAP_KIND';
export const SET_LDAP_DATA = 'SET_LDAP_DATA';

function isSupportKind(kind) {
  return (kind === 'ldap' || kind === 'ad');
}

const getInitialState = () => ({
  exists: false,
  defaults: {
    ldap: null,
    ad: null
  },
  kind: 'none',
  ldap: {},
  ad: {}
});

const baseState = {
  kind: 'none',
  enabled: false,
  advanced: false,
  host: '',
  port: 389,
  bind_dn: '',
  bind_password: '',
  search_base_dn: '',
  search_filter: '',
  user_search_id_attr: '',
  user_search_login_attr: '',
  group_search_id_attr: '',
  group_name_attr: ''
};

export const ldap = {
  namespaced: true,
  state: getInitialState,
  mutations: {
    [FETCH_LDAP_DEFAULTS_SUCCESS](state, payload) {
      if (payload && isSupportKind(payload.kind) && payload.data) {
        state.defaults[payload.kind] = payload.data;
        state[payload.kind] = merge({}, baseState, state.defaults[payload.kind], state[payload.kind]);
      }
    },
    [FETCH_LDAP_DEFAULTS_ERROR](state, payload) {
      if (payload && isSupportKind(payload.kind)) {
        state.defaults[payload.kind] = null;
      }
    },
    [FETCH_LDAP_SUCCESS](state, payload) {
      state.exists = !!payload?.kind;
      if (isSupportKind(payload.kind)) {
        state.kind = payload.kind;
        state[payload.kind] = merge(state[payload.kind], baseState, state.defaults[payload.kind], payload);

        if (!payload.enabled) {
          state.kind = 'none';
        }
      } else {
        state.kind = 'none';
      }
    },
    [FETCH_LDAP_ERROR](state) {
      state.kind = 'none';
    },
    [SET_LDAP_KIND](state, kind) {
      if (isSupportKind(kind)) {
        state.kind = kind;
      } else {
        state.kind = 'none';
      }
    },
    [SET_LDAP_DATA](state, data) {
      if (isSupportKind(state.kind)) {
        state[state.kind] = merge(state[state.kind], baseState, state.defaults[state.kind], data);
      }
    },
    FLUSH_STATE(state) {
      Object.assign(state, getInitialState());
    },
  },
  actions: {
    [FETCH_LDAP](context) {
      return fetchLdap(this.$api)
        .then(async (response) => {
          if (response?.data) {
            if (isSupportKind(response.data.kind) && response.data.enabled) {
              await context.dispatch(FETCH_LDAP_DEFAULTS, response.data.kind);
            }
            context.commit(FETCH_LDAP_SUCCESS, response.data);
          } else if (response && response.data === null) {
            context.commit(FETCH_LDAP_SUCCESS, {});
          } else {
            context.commit(FETCH_LDAP_ERROR);
          }
        })
        .catch((error) => {
          context.commit(FETCH_LDAP_ERROR, error?.data);
          throw error;
        });
    },

    [FETCH_LDAP_DEFAULTS]({ state, commit }, kind) {
      if (isSupportKind(kind) && !state.defaults[kind]) {
        return fetchLdapDefault(this.$api, kind)
          .then((response) => {
            if (response?.data) {
              commit(FETCH_LDAP_DEFAULTS_SUCCESS, { kind, data: response?.data });
            } else {
              commit(FETCH_LDAP_DEFAULTS_ERROR, { kind });
            }
          })
          .catch((error) => {
            commit(FETCH_LDAP_DEFAULTS_ERROR, { kind, data: error?.data });
            throw error;
          });
      }
      return Promise.resolve();
    },
    [SAVE_LDAP]({ state, commit }) {
      let resultPromise;

      if (isSupportKind(state.kind)) {
        resultPromise = saveLdap(this.$api, !state.exists, merge({}, state[state.kind], {
          kind: state.kind,
          enabled: true
        }));
      } else if (state.exists) {
        resultPromise = saveLdap(this.$api, false, { enabled: false });
      }

      if (resultPromise) {
        return resultPromise.then((response) => {
          commit(FETCH_LDAP_SUCCESS, response.data);
          return response;
        });
      }
      return Promise.resolve();
    }
  }
};
